module.exports = __webpack_public_path__ + "static/media/quickbooks_logo_2024.fe612719.png";